var configForDevelopment = {
  baseUrl: "https://localhost:44346",
  development: true
};

var configForServer = {
  baseUrl: window.location.origin, //because the api and client app is in the same web app on azure, just get the origin
  development: false
};

var AppConfig;

if (window.location.hostname === "localhost") {
  AppConfig = configForDevelopment;
} else {
  AppConfig = configForServer;
}

export default AppConfig;